import { DataGrid } from 'src/common/DataGrid';
import {
  InvoicePaymentRead,
  TilledPaymentMethodResponse,
} from 'src/common/external/bambi-api/bambiApi';

import { columns, InvoicePaymentWithPaymentMethod } from './paymentColumns';

interface PaymentsDataGridProps {
  payments?: InvoicePaymentRead[];
  paymentMethods?: TilledPaymentMethodResponse[];
}

export function PaymentsDataGrid({
  payments = [],
  paymentMethods = [],
}: PaymentsDataGridProps) {
  const mergedData: InvoicePaymentWithPaymentMethod[] = payments.map(
    (payment) => {
      return {
        ...payment,
        paymentMethod: paymentMethods.find(
          (m) => m.id === payment.external_payment_method_id
        ),
      };
    }
  );

  return (
    <DataGrid
      tableId="payments"
      columns={columns}
      data={mergedData}
      includePagination={false}
    />
  );
}
